import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import legalEntities from 'modules/core/store/collections/legalEntities'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { useSplitTimeSettingsCustomTimeRangeCategories } from 'modules/payroll_bundle/pages/settings/ZucchettiIntegration/split_custom_time_range_categories/useSplitTimeSettingsCustomTimeRangeCategories'
import EmployeesData from 'modules/payroll_integrations/components/Content/EmployeeData'
import Table from 'modules/payroll_integrations/components/Table'
import PayrollIntegration from 'modules/payroll_integrations/lib/catalog'
import type { Codeable, ColumnNames } from 'modules/payroll_integrations/lib/types'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'

import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'

const ZucchettiIntegration = () => {
  const { company } = useCurrentSession()

  const INTEGRATION_NAME = PayrollIntegration.zucchetti

  const COLUMN_NAMES: ColumnNames = [
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_zucchetti.settings.form.header.concept'
      ),
      colSpan: 4,
      attribute: 'concept',
    },
    {
      name: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_zucchetti.settings.form.header.value'
      ),
      colSpan: 4,
      attribute: 'value',
    },
  ]

  const { splitCustomTimeRangeCategories } = useSplitTimeSettingsCustomTimeRangeCategories(
    company.id
  )

  const { loading } = useAsyncData(() => {
    return Promise.all([leaveTypes.fetch()])
  }, [])

  const codeables: Record<string, Codeable> = {
    legalEntity: {
      position: 0,
      collection: legalEntities,
      class: 'LegalEntity',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_zucchetti.settings.form.concept.legal_entity'
      ),
    },
    leave_type: {
      position: 1,
      collection: leaveTypes.filter((lt) => lt.isActive),
      class: 'Timeoff::LeaveType',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_zucchetti.settings.form.concept.leave_type'
      ),
    },
    splitCustomTimeRangeCategory: {
      position: 2,
      collection: splitCustomTimeRangeCategories,
      class: 'TimeSettings::SplitCustomTimeRangeCategory',
      label: i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_zucchetti.settings.form.concept.custom_time_category'
      ),
    },
  }

  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body variant="full" loading={loading} error={null}>
        <Table columnNames={COLUMN_NAMES} codeables={codeables} integration={INTEGRATION_NAME} />
        <EmployeesData
          integration_name={i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_zucchetti.integration_name'
          )}
        />
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default ZucchettiIntegration
